import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirects Clerk's conventional auth paths (/sign-up, /sign-in) to this app's
 * routes (/register, /login), preserving the query string and hash so an
 * invitation's `__clerk_ticket` survives the hop and <SignUp> can consume it.
 *
 * Clerk emails, the Account Portal, and existing invitations point at
 * /sign-up|/sign-in (Clerk's defaults), which this SPA has no route for — they
 * would otherwise fall through to the catch-all, lose the ticket, and land the
 * invitee on the sign-in page with "Couldn't find your account".
 */
export function AuthAliasRedirect({ to }: { to: '/register' | '/login' }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
